import { generatePath } from "@routes/utils";

const memberExportExcelPathBase = `/members/export-execl/`;

export const exportExcel = {
  post: () => generatePath(memberExportExcelPathBase, null),
};
